import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 10px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 8px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    &.form-center{
        justify-content: center;
        align-items: center;
    }
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input<{ isStyle: boolean }>`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;

    padding: 10px;
    width: 100%;
    text-align: ${(props) => props.isStyle ? 'start' : 'center'};

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const TextArea = styled.textarea`
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 10px;
    resize: none;

    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

//Table
export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 2px 2px 8px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 8px;
    padding: 3px 5px;
    max-height: 350px;
    height: 350px;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    
    /* Opcional: Scroll mais suave */
    scroll-behavior: smooth;

    &::-webkit-scrollbar { 
        width: 5px;
        height: 8px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const Table = styled.table`
    width: 100%;
    min-width: 600px;
    border-collapse: collapse;
    
    @media (max-width: 768px) {
        min-width: 500px;
    }
    
    @media (max-width: 480px) {
        min-width: 450px;
    }
    
    td, th {
        border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
        text-align: center;
        padding: 10px 8px; /* Aumentei o padding horizontal */
        font-size: 12px;
        min-width: 80px; /* Largura mínima para cada coluna */
        white-space: nowrap;
    }
`;

export const Thead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    th {
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
        min-width: 100px; /* Largura mínima para headers */
        
        @media (max-width: 768px) {
            min-width: 90px;
            padding: 8px 6px;
        }
    }
`;

export const Tbody = styled.tbody`
    td:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_50 || '#f8f9fa'};
    }
`;

export const Td = styled.td``;

export const Tr = styled.tr`
`;

export const TdStyle = styled.td`
    font-weight: 500;
    font-size: 14px;
`;

export const ContentInfor = styled.div``;

export const InforTitle = styled.p`
    font-size: 24px;
    font-weight: 500;
`;

export const Infor = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`

export const Subtitle = styled.p`
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const InforDescription = styled.p`
    font-size: 14px;
`;

export const Text = styled.p`
    font-size: 10px;
    color: ${(props) => props.theme.colors.gray.gray_500};
    
    &.title{
        font-size: 16px;
        color: ${(props) => props.theme.colors.gray.gray_800};
        font-weight: 500;

    }
    span{
        color: ${(props) => props.theme.colors.gray.gray_800};
        font-weight: 500;
    }
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const HeaderSection = styled.div`
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
`;

export const BodySection = styled.div`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    padding: 8px 16px;
`;

export const ContentGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;
